import { configureStore } from '@reduxjs/toolkit';
import rootReducer from '../redux';
import { cdmApi } from '../API';
// import * as api from 'core/api';

// add another middleware if we want
// const middleware = [ThunkMiddleware.withExtraArgument({ api }), promise];
// //const store = createStore(rootReducer, composeWithDevTools(applyMiddleware(...middleware)));
// todo: change devtool to false when going in prod mode
const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({ immutableCheck: false, serializableCheck: false }).concat(cdmApi.middleware),
});

export default store;
